<template>
  <div id="viplist">
    <el-dialog title="新增会员" :visible.sync="dialogFormVisibleLabel">
      <div style="width: 60%; display: inline-block">
        <el-form label-width="140px">
          <el-form-item label="姓名" required>
            <el-input v-model="form.card_owner"></el-input>
          </el-form-item>
          <el-form-item label="手机号" required>
            <el-input v-model="form.mobile" type="number"></el-input>
          </el-form-item>
          <el-form-item label="卡号">
            <el-input v-model="form.card_number" type="number"></el-input>
          </el-form-item>
          <el-form-item label="性别" required>
            <el-radio-group v-model="form.sex">
              <el-radio label="MAN">男</el-radio>
              <el-radio label="WOMAN">女</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="状态">
            <el-select v-model="form.status" placeholder="请选择">
              <el-option label="正常" value="ENABLE"></el-option>
              <el-option label="禁用" value="DISABLE"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div
        class="img_class_insert"
        style="width: 20%; display: inline-block; vertical-align: top"
      >
        <el-upload
          :action="'https://upload-z2.qiniup.com'"
          list-type="picture-card"
          :auto-upload="true"
          :file-list="fileList"
          :on-success="topSuccess"
          :on-error="topSuccess"
          :before-upload="QiniuToken"
          :data="QiniuData"
          :limit="1"
        >
          <i slot="default" class="el-icon-plus"></i>
          <div slot="file" slot-scope="{ file }">
            <img class="el-upload-list__item-thumbnail" :src="file.url" alt />
            <span class="el-upload-list__item-actions">
              <span
                class="el-upload-list__item-preview"
                @click="handlePictureCardPreview(file)"
              >
                <i class="el-icon-zoom-in"></i>
              </span>
              <span
                v-if="!disabled"
                class="el-upload-list__item-delete"
                @click="handleRemove(file)"
              >
                <i class="el-icon-delete"></i>
              </span>
            </span>
          </div>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt />
        </el-dialog>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisibleLabel = false">取 消</el-button>
        <el-button type="primary" @click="onSubmitadd">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="后台扣费" :visible.sync="dialogDeductionVisible" width="60%">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" style="width: 80%">
        <el-form-item label="用户昵称：">
          {{ getFormData.card_owner }}
        </el-form-item>
        <el-form-item label="手机号/IC卡号：">
          {{ getFormData.card_number }}
        </el-form-item>
        <el-form-item label="当前余额：">
          {{ getFormData.balance / 100 }}
        </el-form-item>
        <el-form-item label="扣费金额(元)">
          <el-input-number
              v-model="ruleForm.deductionFee"
              :precision="2"
              :step="0.1"
              :max="1000000000"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="备注"  prop="deductionRemark">
          <el-input v-model="ruleForm.deductionRemark" style="width: 200px">
          </el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogDeductionVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSubmitDeduction">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="发放优惠券" :visible.sync="dialogCouponVisible" width="60%">
      <el-form :model="couponForm" :rules="couponRules" ref="couponForm" label-width="180px" style="width: 80%">
        <el-form-item label="优惠券名称"  prop="name">
          <el-input v-model="couponForm.name" style="width: 400px">
          </el-input>
        </el-form-item>
        <el-form-item label="优惠券类型"  prop="type">
          <el-select v-model="couponForm.type" placeholder="请选择"
                     style="width: 400px"
          >
            <el-option
                v-for="item in couponOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="满减起价或者是折扣起价"  prop="limit">
          <el-input v-model="couponForm.limit" style="width: 400px">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="满减减多少,折扣打几折"  prop="discount">
          <el-input v-model="couponForm.discount" style="width: 400px">
            <template slot="append">元/折</template>
          </el-input>
        </el-form-item>
        <el-form-item label="有效期">
          <el-date-picker
              v-model="couponForm.timeRange"
              type="datetimerange"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="请选择门店"  prop="shop_id" style="margin-right: 20px">
          <el-select
              multiple
              v-model="couponForm.shop_id"
              placeholder="请选择"
              style="width: 400px"
          >
            <el-option
                v-for="index in shops"
                v-bind:key="index.id"
                :label="index.name"
                :value="index.id"
            ></el-option>
          </el-select>
        </el-form-item>

      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogCouponVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSubmitCoupon">确 定</el-button>
      </div>
    </el-dialog>


    <el-dialog title="消费记录" :visible.sync="dialogFormVisible" width="60%">
      <el-row :gutter="30" style="width: 70%; margin: 30px auto">
        <el-col :span="12">
          <div class="top-orderdetil">
            用户昵称：<span class="ztcolor">{{ getFormData.card_owner }}</span>
          </div>
          <div class="top-orderdetil">
            累计充值：<span class="ztcolor">{{
              getFormData.total_recharge_amount / 100
            }}</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="top-orderdetil">
            手机号码：<span class="ztcolor">{{ getFormData.mobile }}</span>
          </div>
          <div class="top-orderdetil">
            当前余额：<span class="red">{{ getFormData.balance / 100 }}</span>
          </div>
        </el-col>
      </el-row>

      <el-table
        :data="historyTableData"
        border
        style="width: 70%; margin: auto"
        :header-cell-style="() => 'text-align: center;background:#eef1f6;'"
      >
        <el-table-column label="订单时间" width="180" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.created_at | datetime }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="order_id" label="订单编号" align="center">
        </el-table-column>

        <el-table-column label="商品名称" width="120" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.order.name }}</span>
          </template>
        </el-table-column>

        <el-table-column label="订单状态" align="center">
          <template slot-scope="scope">
            {{ scope.row.order.status | payStateString }}
          </template>
        </el-table-column>
        <el-table-column label="订单金额" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.order.total_price / 100 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="消费金额" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.change_balance / 100 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="备注" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.remark }}</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- <el-pagination
        class="pagination"
        @current-change="fromPageSize"
        background
        layout="prev, pager, next"
        :total="from.total"
        :page-size="from.page_size"
      ></el-pagination> -->
    </el-dialog>


    <div class="top_div">
      <el-form :inline="true" :model="formInline">
        <!-- <el-form-item label="请选择门店">
          <el-select placeholder="请选择" value>
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>
        </el-form-item> -->
        <div class="demo-form-inline">
          <el-form-item label="昵称">
            <el-input v-model="formInline.owner"></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="formInline.mobile"></el-input>
          </el-form-item>
          <el-form-item label="按起止时间">
            <!-- <el-time-picker
              is-range
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              placeholder="选择时间范围"
            ></el-time-picker> -->
            <el-date-picker
              v-model="formInline.date"
              type="datetimerange"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="请选择"
              class="dateInput"
            ></el-date-picker>
          </el-form-item>

          <!-- <el-form-item label="渠道">
            <el-select v-model="formInline.channel" placeholder="请选择">
              <el-option label="全部" value=""></el-option>
              <el-option label="微信" value="WEIXIN"></el-option>
              <el-option label="IC卡" value="MAGCARD"></el-option>
            </el-select>
          </el-form-item>
           -->
            <el-form-item label="会员类别">
          <el-select v-model="formInline.channel" placeholder="请选择">
            <el-option label="所有会员" value=""></el-option>
            <el-option label="小程序会员" value="WEIXIN"></el-option>
            <el-option label="IC卡会员" value="MAGCARD"></el-option>
          </el-select>
        </el-form-item>

          <el-form-item label="状态">
            <el-select v-model="formInline.status" placeholder="请选择">
              <el-option label="全部" value=""></el-option>
              <el-option label="正常" value="ENABLE"></el-option>
              <el-option label="禁用" value="DISABLE"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="bottom_center">
          <el-form-item style="min-width: 150px">
            <el-button
              type="primary"
              style="background: #1890ff"
              @click="pageSize(1)"
              >查询</el-button
            >
 <el-button
            type="primary"
            class="vubutton"
            @click="onSubmit"
          >重置</el-button>

            <download-excel
              :fetch="fetchData"
              :fields="json_fields"
              :before-generate="startDownload"
              name="会员列表.xls"
              style="display: inline-block; margin-left: 10px"
            >
              <el-button
                type="primary"
                :loading="upload"
                style="
                  background: #1baeae;
                  color: #fff;
                  border: none;
                  height: 40px;
                "
                >导出</el-button
              >
            </download-excel>
          </el-form-item>
        </div>
      </el-form>
      <div style="margin-bottom: 10px">
        <el-button
          type="primary"
          class="vubutton"
          style="
            background: rgb(34, 153, 155);
            color: #fff;
            border: none;
            height: 40px;
            margin-right: 20px;
          "
          @click="dialogFormVisibleLabel = true"
          >+新增会员</el-button
        >
        会员合计：<span>{{ total || 0 }}</span>
      </div>

      <el-table
        :fit="false"
        border
        :data="tableData"
        style="width: auto"
        :cell-style="() => 'text-align: center;'"
        :header-cell-style="() => 'text-align: center;background:#eef1f6;'"
      >
        <template slot="empty">
          <noCart></noCart>
        </template>
        <el-table-column label="注册时间" width="210">
          <template slot-scope="scope">
            <span>{{ scope.row.created_at | datetime }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="时间" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="手机号" width="210">
          <template slot-scope="scope">
            <span>{{ scope.row.mobile }}</span>
          </template>
        </el-table-column>
        <el-table-column label="昵称" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.card_owner }}</span>
          </template>
        </el-table-column>
        <el-table-column label="会员类别" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.channel | channelString }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.status == 'ENABLE' ? '正常' : '禁用' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="300">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="handleEdita(scope.row, 'DISABLE')"
              v-if="scope.row.status == 'ENABLE'"
              >禁用</el-button
            >
            <el-button
              size="mini"
              @click="handleEdita(scope.row, 'ENABLE')"
              v-else
              >启用</el-button
            >
            <el-button size="mini" @click="getFormlist(scope.row)"
              >查看消费</el-button
            >
            <el-button size="mini" @click="doDeductionFee(scope.row)"
                       style="color: rgb(28, 165, 160)"
            >后台扣费</el-button>
            <el-button size="mini" @click="doCoupon(scope.row)"
            >发优惠券</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="pageSize"
        class="pagination_em"
        background
        :current-page="page_no"
        layout="prev, pager, next"
        :total="total"
      ></el-pagination>

      <!-- <download-excel
        class="export-excel-wrapper"
        :data="json_data"
        :fields="json_fields"
        header="这是个excel的头部"
        name="导出的表格名称.xls"
      >
        <el-button type="primary" size="small">导出EXCEL</el-button>
      </download-excel> -->
    </div>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  name: 'employee',
  data() {
    return {
      shops:[],
      couponOptions: [{
        value: 'CASH_BACK',
        label: '立减'
      }, {
        value: 'DISCOUNT',
        label: '打折'
      }, {
        value: 'REBATE',
        label: '满减'
      }],
      ruleForm: {
        deductionRemark : '',
        deductionFee: 0
      },
      couponForm: {
        couponName: '',
        couponType: '',
        couponLimit: 0,
        couponDiscount: 0,
        timeRange: [],
        shop_id: []
      },
      json_fields: {
        ID: 'id',
        卡号: 'card_number',
        姓名: 'card_owner',
        注册时间: 'created_at',
        手机号: 'mobile', //如果命名的标题有空格,需要用双引号
        会员类型: 'channel',
        状态: 'statusstring',
      },
      upload: false,
      rules: {
        deductionRemark: [
          {required: true, message: '请输入备注', trigger: 'blur'},
        ],
        deductionFee: [
          {required: true, message: '金额必须大于0', trigger: 'blur'},
        ],
      },
      couponRules:{
        name: [
          {required: true, message: '请输入优惠券名称', trigger: 'blur'},
        ],
        type: [
          {required: true, message: '请输入优惠券类型', trigger: 'blur'},
        ],
        shop_id: [
          {required: true, message: '请输入可用店铺', trigger: 'blur'},
        ]
      },
      formInline: {
        owner: '',
        start: '',
        end: '',
        status: '',
        mobile: '',
        channel: '',
        date: [],
      },
      QiniuData: {
        // key: '', //图片名字处理
        token: '', //七牛云token
      },
      fileList: [],
      dialogImageUrl: '',
      dialogVisible: false,
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      dialogFormVisibleLabel: false,
      dialogFormVisible: false,
      dialogDeductionVisible: false,
      dialogCouponVisible: false,
      tableData: [],
      total: 0,
      page_no: 1,
      card_num: '',
      form: {
        total: '',
        page_size: 10,
        card_owner: '',
        sex: 'MAN',
        avatar: '',
        card_number: '',
        mobile: '',
        status: '',
      },
      getFormData: {
        page_no: 1,
      },
      historyTableData: [],
    };
  },

  methods: {
    async fetchData() {
      const url = this.$userList.user_vip_list;

      const res = await this.$http.get(url, {
        page_size: this.total,
        page_no: this.page_no,
        mobile: this.formInline.mobile,
        owner: this.formInline.owner,
        status: this.formInline.status,
        start: (this.formInline.date && this.formInline.date[0]) || '',
        end: (this.formInline.date && this.formInline.date[1]) || '',
      });
      // console.log(af);
      let userdata = res.data.magcard || [];
      userdata.map((item) => {
        item.id = item.id.toString();
        item.created_at = this.dateString(item.created_at);
      });
      this.upload = false;
      // console.log('userdata: ', userdata);
      return userdata;
    },
    dateString(timeStamp) {
      var date = new Date(timeStamp);

      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      var h = date.getHours();
      h = h < 10 ? '0' + h : h;
      var minute = date.getMinutes();
      var second = date.getSeconds();
      minute = minute < 10 ? '0' + minute : minute;
      second = second < 10 ? '0' + second : second;
      return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
    },
    startDownload() {
      this.upload = true;
      // alert('show loading');
    },
     onSubmit() {
      console.log('submit!');
      // const shop_id = this.formInline.shop_id;
      this.formInline = {
         owner: '',
          start: '',
          end: '',
          status: '',
          mobile: '',
          channel: '',
          date: [],
      };
       this.page_no = 1;
      this.getList();
    },
    getList() {
      //  owner=trump&card_num=a0000
      // this.listloading = true;
      const url = this.$userList.user_vip_list;
      this.$http
        .get(url, {
          page_size: 10,
          page_no: this.page_no,
          mobile: this.formInline.mobile,
          owner: this.formInline.owner,
          status: this.formInline.status,
          channel: this.formInline.channel,
          start: (this.formInline.date && this.formInline.date[0]) || '',
          end: (this.formInline.date && this.formInline.date[1]) || '',
        })
        .then((res) => {
          // this.listloading = false;
          if (res.code === 200) {
            // console.log(res);
         
              let tableData = res.data.magcard;
            this.tableData = tableData.map((item) => {
               item.statusstring = item.status == 'ENABLE' ? '正常' : '禁用';
                return item;
            });

            this.total = res.data.total;
      
          } else {
            //res.message && this.$alert(res.message);
          }
        });
    },
    async QiniuToken() {
      const url = this.$userList.user_status_qiniutoken_dish;
      const data = await this.$http.get(url).then((res) => {
        return res;
      });
      if (data.code === 200 && data.data.up_token) {
        this.QiniuData.token = data.data.up_token;
        this.QiniuData.url_prefix = data.data.url_prefix;
        return true;
      } else {
        return false;
      }
    },
      
    handleRemove(file) {
      this.fileList = this.fileList.filter((item) => {
        if (item.name !== file.name) {
          return item;
        }
      });
      console.log(file);
    },
    handleEdita(userData, state) {
      this.$confirm(`确认${state == 'DISABLE' ? '禁用' : '启用'}该用户？`, '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          const url = this.$userList.user_stateCharge;
          this.$http
            .post(url, {
              magcard_id: userData.id,
              status: state,
            })
            .then((res) => {
              if (res.code === 200) {
                // this.dialogFormVisibleLabel = false;
                this.getList();
                this.$message({
                  type: 'success',
                  message: `${state == 'DISABLE' ? '禁用' : '启用'}成功!`,
                });
              } else {
              }
            });
        })
        .catch(() => {});
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    topSuccess(event, file, fileList) {
      // console.log(fileList);
      this.fileList = fileList.map((item) => {
        if (item.response) {
          item.name = item.response.hash;
          item.url = this.QiniuData.url_prefix + '/' + item.response.hash;
        }
        return item;
      });
      this.form.avatar = this.fileList[0].url;
    },
    onSubmitDeduction(){
      this.$refs['ruleForm'].validate((valid) => {
        console.log(valid)
        if (valid) {
          const url = this.$userList.user_cardRCharge;
          this.$http
              .post(url, {
                magcard_id: this.getFormData.id,
                channel:this.getFormData.channel,
                balance: Math.round(this.ruleForm.deductionFee * 100),
                remark: this.ruleForm.deductionRemark,
              })
              .then((res) => {
                if (res.code === 200) {
                  // this.dialogFormVisibleLabel = false;
                  this.getList();
                  this.$message({
                    type: 'success',
                    message: `扣费成功!`,
                  });
                } else {
                  this.$message({
                    type: 'error',
                    message: `扣费失败! ` + res.message,
                  });
                }
                this.dialogDeductionVisible = false
                this.getFormData = {}
              });
        } else {
          return false;
        }
      })
    },
    onSubmitCoupon() {
      this.$refs['couponForm'].validate((valid) => {
            console.log(valid)
            if (valid) {
              const url = this.$userList.create_coupon
              let coupon_scopes = []
              for (let shop of this.couponForm.shop_id) {
                coupon_scopes.push({
                  shop_id: shop
                })
              }
              this.$http
                  .post(url, {
                    coupon: {
                      name: this.couponForm.name,
                      ctype: this.couponForm.type,
                      total_amount: 1,
                      discount_price: parseInt(this.couponForm.discount * 100),
                      base_price_limit: parseInt(this.couponForm.limit * 100),
                      restriction: 'ONE_PERSON_ONE_TIME',
                      restriction_count: 1,
                      status: 'ENABLED',
                      start_date: moment(this.couponForm.timeRange[0]).format("YYYY-MM-DD hh:mm:ss"),
                      end_date: moment(this.couponForm.timeRange[1]).format("YYYY-MM-DD hh:mm:ss"),
                      send_for: 'Client'
                    },
                    coupon_scopes: coupon_scopes

                  }).then((res) => {
                if (res.code === 200) {
                  let couponId = res.data.id
                  let url = this.$userList.send_coupon
                  url = url + couponId + "/" + this.getFormData.id
                  this.$http.get(url).then(res => {
                    if (res.code === 200) {
                      this.dialogCouponVisible = false
                      this.couponForm = {}
                      this.getFormData = {}
                      this.$message({
                        type: 'info',
                        message: `优惠券发放成功! ` + res.message,
                      });
                    } else {
                      this.$message({
                        type: 'error',
                        message: `发放优惠券失败! ` + res.message,
                      });
                    }
                  })
                } else {
                  this.$message({
                    type: 'error',
                    message: `发放优惠券失败! ` + res.message,
                  });
                }
              })
            } else {
              return false
            }
          }
      )
    },
    fromPageSize(index, row) {
      console.log(index, row);
    },
    pageSize(index) {
      // console.log('index: ', index);
      this.page_no = index;
      this.getList();
    },
    onSubmitadd() {
      if (this.form.card_owner.length <= 0) {
        this.$message({
          type: 'error',
          message: '请输入名称',
        });
        return;
      }

      var reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (!reg_tel.test(this.form.mobile)) {
        this.$message({
          type: 'error',
          message: '手机号错误!',
        });
        return;
      }
      if (this.form.avatar.length <= 0) {
        this.$message({
          type: 'error',
          message: '请上传头像信息!',
        });
        return;
      }
      const url = this.$userList.user_vip_add;
      this.$http
        .post(url, {
          mobile: this.form.mobile,
          card_owner: this.form.card_owner,
          status: this.form.status,
          card_number: this.form.card_number,
          avatar: this.form.avatar,
          sex: this.form.sex,
        })
        .then((res) => {
          if (res.code === 200) {
            this.dialogFormVisibleLabel = false;
            this.getList();
            this.$message({
              type: 'success',
              message: '新增成功!',
            });
            this.form = {
              total: '',
              page_size: 10,
              card_owner: '',
              sex: 'MAN',
              avatar: '',
              card_number: '',
              mobile: '',
              status: '',
            };
          } else {
          }
        });
    },
    doDeductionFee(row){
      this.ruleForm = {}
      this.getFormData = row
      this.dialogDeductionVisible = true
    },
    doCoupon(row) {
      this.couponForm = {}
      this.getFormData = row
      this.dialogCouponVisible = true
    },
    getFormlist(userData) {
      if (userData) {
        this.getFormData = userData;
        this.getFormData.page_no = 1;
      }
      this.dialogFormVisible = true;
      const url = this.$userList.user_cardHistory_list;
      this.$http
        .get(url + userData.id, {
          page_size: 10,
          page_no: this.getFormData.page_no,
          mode: 'CHARGE',
        })
        .then((res) => {
          // this.listloading = false;
          if (res.code === 200) {
            // console.log(res);
            // this.total = res.data.total;
            this.historyTableData = res.data.magcard_history;
            this.getFormData.total_recharge_amount =
              res.data.total_recharge_amount;
          } else {
            //res.message && this.$alert(res.message);
          }
        });
    },
    handleEdit(index, row) {
      console.log(index, row);
    },
    handleDelete(index, row) {
      console.log(index, row);
    },
    getType() {
      const url = this.$userList.user_restaurant_list + `/0/999`;
      this.$http.get(url).then((res) => {
        if (res.code === 200) {
          this.shops = res.data.items;
        } else {
          res.message && this.$alert(res.message);
        }
      });
    }
  },
  created() {
    this.getType()
    this.getList()
    this.$root.headName = ['会员管理', '会员列表'];
  },
};
</script>

<style lang="scss" scoped>
#viplist {
  width: 100%;
  height: auto;
  position: relative;
}
.top_div {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 20px;
  background: #fff;
}
.demo-form-inline {
  display: flex;
  justify-content: flex-start;
}
/* .el-select > .el-input,
.el-input__inner {
  width: 300px;
} */
.vubutton {
  background: #fff;
  border: solid 1px #1890ff;
  color: #1890ff;
}
.el-button--primary:hover,
.el-button--primary:active,
.el-button--primary:focus {
  background: #1890ff;
  border-color: #1890ff;
}
.el-table--group::after,
.el-table--border::after,
.el-table::before {
  background: none;
}
.el-form--inline .el-form-item {
  margin-right: 50px;
}
.center_div {
  margin-top: 20px;
  background: #fff;
  box-sizing: border-box;
  padding: 20px;
}
.el-table__empty-block {
  width: none !important;
}
.center_div_border {
  margin-top: 20px;
  width: 100%;
  min-height: 300px;
  background: brown;
}
.bottom_center {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
</style>
